import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "syndicate__card__detail" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info__size" }
const _hoisted_5 = { class: "info__type" }
const _hoisted_6 = { class: "info__price" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "name__name" }
const _hoisted_11 = { class: "syndicate__card__description" }
const _hoisted_12 = { class: "remaining-share" }
const _hoisted_13 = { class: "details" }
const _hoisted_14 = { class: "details__date" }
const _hoisted_15 = { class: "details__type" }

import "@/../../css/lotteries/syndicates/syndicates-partials/syndicates-card.scss";
import { computed, ref, watch } from "vue";
import useSyndicateDetails from "@/lotteries/composables/syndicates/use-syndicate-details";
import FillTrack from "./fill-track-detail.vue";
import { SyndicatePreview } from "@/lotteries/model/syndicates/syndicate-preview";
import { StringUtils } from "@sazka/utils/string-utils";
import SyndicateDetail from "@/lotteries/components/syndicates/_syndicate-detail.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'syndicate-card',
  props: {
    carouselCard: { type: Boolean },
    data: {}
  },
  setup(__props: any) {

const props = __props;

const syndicate = computed(() => props.data);

const showDetailComponent = ref(false);
const showDetail = () => {
    showDetailComponent.value = true;
};

const { syndicateDefinition, syndicateImage, syndicateTotalPartsLabel, syndicateDrawDateFormatted } =
    useSyndicateDetails(syndicate);

const betName = computed(() => {
    const name = syndicate.value.name;

    return name.length > 50 ? name.substring(0, 51) + "..." : name;
});

const betHref = computed(() => {
    return `/s/${syndicate.value.wagerId}`;
});

// history api magic below

// detail was opened first (loading of syn. cards was suppressed) -> push new state when cards are loaded (detail was closed)
if (window.location.href.includes("/loterie/skupinove-sazeni/detail/" + syndicate.value.wagerId)) {
    window.history.pushState(
        { referrer: "/loterie/skupinove-sazeni/detail/" + syndicate.value.wagerId },
        document.title,
        "/loterie/skupinove-sazeni/skupinove-sazky"
    );
}

const preventHistoryPush = ref(false);
watch(showDetailComponent, (showingDetail) => {
    const referrer = window.history.state?.referrer;

    if (preventHistoryPush.value) {
        preventHistoryPush.value = false;
        return;
    }

    const detailUrl = "/loterie/skupinove-sazeni/detail/" + syndicate.value.wagerId;

    window.history.pushState(
        { referrer: window.location.href },
        document.title,
        showingDetail ? detailUrl : referrer ?? detailUrl
    );
});
window.addEventListener("popstate", (event) => {
    if (window.location.href.includes("/detail/" + syndicate.value.wagerId)) {
        if (!window.history.state) {
            // opened direct detail link, closed detail and navigated back in browser (back to detail) edge case
            window.history.replaceState(
                { referrer: "/loterie/skupinove-sazeni/skupinove-sazky" },
                document.title,
                document.location.href
            );
        }
        preventHistoryPush.value = true;
        showDetail();
        // prevent other components with the same ID showing (and overwriting) detail in this component
        event.stopImmediatePropagation();
        event.stopPropagation();
    } else {
        // if detail is opened, watcher would push new state and thus opening detail again (case: detail is opened and you navigate back in browser )
        if (showDetailComponent.value) {
            preventHistoryPush.value = true;
        }
        showDetailComponent.value = false;
    }
});

const { formatCurrency } = StringUtils;

return (_ctx: any,_cache: any) => {
  return (syndicate.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
            'c c-5 c-xs2-4 c-sm-4 c-sm2-6 c-md-4 c-lg-5 c-xl-6 keen-slider__slide': _ctx.carouselCard,
            'c c-12 c-sm-6 c-md-4': !_ctx.carouselCard,
        })
      }, [
        _createElementVNode("a", {
          href: betHref.value,
          class: "syndicate__card",
          onClick: _withModifiers(showDetail, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(syndicateDefinition).size), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(syndicateDefinition).lottery), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "info__price__amount",
                  innerHTML: _unref(formatCurrency)(_unref(syndicateDefinition).sharePrice)
                }, null, 8, _hoisted_7),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "info__price__portion" }, "za 1 podíl", -1))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["bg-img", syndicate.value.lottery.replace('sportkamh', 'sportka')]),
              innerHTML: _unref(syndicateImage)
            }, null, 10, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(betName.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, "Zbývá " + _toDisplayString(syndicate.value.unsoldParts) + " z " + _toDisplayString(_unref(syndicateTotalPartsLabel)), 1),
              _createVNode(FillTrack, {
                lottery: syndicate.value.lottery,
                totalParts: _unref(syndicateDefinition).shareCount,
                unsoldParts: syndicate.value.unsoldParts
              }, null, 8, ["lottery", "totalParts", "unsoldParts"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-date" }, null, -1)),
                _createElementVNode("time", null, _toDisplayString(_unref(syndicateDrawDateFormatted)), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icon-checkbox" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(syndicateDefinition).name), 1)
              ])
            ])
          ])
        ], 8, _hoisted_1),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (showDetailComponent.value)
            ? (_openBlock(), _createBlock(SyndicateDetail, {
                key: 0,
                wagerId: syndicate.value.wagerId,
                onClosed: _cache[0] || (_cache[0] = ($event: any) => (showDetailComponent.value = false))
              }, null, 8, ["wagerId"]))
            : _createCommentVNode("", true)
        ]))
      ], 2))
    : _createCommentVNode("", true)
}
}

})